import { render } from "./MembershipFeaturedWatches.vue?vue&type=template&id=06089a8c"
import script from "./MembershipFeaturedWatches.vue?vue&type=script&lang=js"
export * from "./MembershipFeaturedWatches.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__